import React from 'react';
import { withPlaceholder, Text } from '@sitecore-jss/sitecore-jss-react';
import ColorBlockCalloutComponent from '@component/ColorBlockCalloutComponent';

const ColorBlockCallout = (props) => {
  const themeObject = props.params.Theme === undefined ? '' : JSON.parse(props.params.Theme);
  const themeColor = themeObject?.Color === undefined ? '' : themeObject?.Color.value;

  return (
    <>
      <ColorBlockCalloutComponent text={<Text field={props.fields.content} />} variant={themeColor} />
    </>
  );
};
export default withPlaceholder('jss-color-callout')(ColorBlockCallout);
